export default "__VITE_ASSET__c539c860__"